import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  borderBox: {
    padding: 0,
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 15,
    cursor: 'pointer',
  },
}));
